// extracted by mini-css-extract-plugin
export default {"loader-container":"spinner_loader-container__pM-UE","loader":"spinner_loader__SyDAO","load":"spinner_load__3UgF2","loader--small":"spinner_loader--small__QtUGk"};